import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';
import { FieldDTO } from '../../core/models/field-gui-model.model';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'encodedParamValue',
    pure: false,
})
export class EncodedFieldParamPipe implements PipeTransform {
    constructor(private windowRef: WindowRef) {}

    transform(field: FieldDTO): string {
        const fieldList = [{ key: field.id, value: field.value }];

        return this.windowRef.nativeWindow.btoa(unescape(encodeURIComponent(JSON.stringify(fieldList))));
    }
}
